export const bazaar = '/market/';
export const bazaarSellerSearch = `${bazaar}seller/search/`;
